import React, { useId } from 'react';
import ChangedDot from './ChangedDot';
import './sheet.css';

/**
 * Γραμμή μέσα σε ενότητα: τίτλος/υπότιτλος αριστερά, διακόπτης ή επιλογή δεξιά, λεπτή γραμμή ανάμεσα
 * σε διαδοχικές γραμμές. Το `control` ως συνάρτηση παίρνει τα ids, ώστε ο διακόπτης να έχει ως όνομα
 * τον τίτλο και ως περιγραφή τον υπότιτλο (aria-labelledby / aria-describedby).
 */
export interface SheetRowIds {
  labelId: string;
  descriptionId?: string;
}

export interface SheetRowProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Δεύτερη, πιο αχνή γραμμή (π.χ. τι χρειάζεται για να δουλέψει). */
  note?: React.ReactNode;
  changed?: boolean;
  control: React.ReactNode | ((ids: SheetRowIds) => React.ReactNode);
  /** Σταθερό id για τον τίτλο (αλλιώς useId). */
  labelId?: string;
}

export const SheetRow: React.FC<SheetRowProps> = ({ title, subtitle, note, changed = false, control, labelId: labelIdProp }) => {
  const uid = useId();
  const labelId = labelIdProp || `${uid}-label`;
  const subId = subtitle ? `${labelId}-sub` : undefined;
  const noteId = note ? `${labelId}-note` : undefined;
  const descriptionId = [subId, noteId].filter(Boolean).join(' ') || undefined;
  return (
    <div className="xs-row">
      <div className="xs-row-text">
        <span id={labelId} className="xs-row-title">
          {title}
          {changed && <ChangedDot />}
        </span>
        {subtitle && <p id={subId} className="xs-row-sub">{subtitle}</p>}
        {note && <p id={noteId} className="xs-row-note">{note}</p>}
      </div>
      <div className="xs-row-control">{typeof control === 'function' ? control({ labelId, descriptionId }) : control}</div>
    </div>
  );
};

export default SheetRow;
